import { analyticsEvent } from '@app/packages/analytics/declaration'
import {
  getDirectAnnouncementsById,
  postDirectAnnouncements,
  putDirectAnnouncementsAccept,
  putDirectAnnouncementsCancel,
  putDirectAnnouncementsDecline,
} from '@app/packages/api/v2/actions/direct_announcements'
import type { DirectAnnouncementRequest, PutDirectAnnouncementsAcceptRequest } from '@app/packages/api/v2/types/params'
import { asError } from '@app/packages/asError/asError'

import {
  failDirectAnnouncementLoadSlice,
  finishDirectAnnouncementLoadSlice,
  mergeDirectAnnouncementSlice,
  startDirectAnnouncementLoadSlice,
} from '@app/store/slices/direct_announcement'
import { createThunk } from '@app/store/thunk'

import { getAnalyticsRouter } from './analytics'
import { callV2Api } from './api'

export const fetchDirectAnnouncement = (direct_announcement_id: string) =>
  createThunk(async dispatch => {
    dispatch(startDirectAnnouncementLoadSlice(direct_announcement_id))
    try {
      const resp = await dispatch(callV2Api(getDirectAnnouncementsById(direct_announcement_id)))
      dispatch(mergeDirectAnnouncementSlice(resp.data))
      dispatch(finishDirectAnnouncementLoadSlice(resp.data.id))
      return resp
    } catch (e) {
      dispatch(failDirectAnnouncementLoadSlice(direct_announcement_id, asError(e)))
      throw e
    }
  })

export const createDirectAnnouncement = (request: DirectAnnouncementRequest) =>
  createThunk(async dispatch => await dispatch(callV2Api(postDirectAnnouncements(request))))

export const acceptDirectAnnouncements = (direct_announcement_id: string, request: PutDirectAnnouncementsAcceptRequest) =>
  createThunk(async dispatch => {
    try {
      const resp = await dispatch(callV2Api(putDirectAnnouncementsAccept(direct_announcement_id, request)))
      dispatch(getAnalyticsRouter()).send(
        analyticsEvent(() => ({
          // A sitter accepted a direct announcement.
          type: 'direct_announcement_accept',
          data: { direct_announcement_id },
        })).set('amplitude')
      )
      return resp
    } catch (e) {
      dispatch(getAnalyticsRouter()).send(
        analyticsEvent(() => ({
          // A sitter could not accept a direct announcement.
          type: 'direct_announcement_accept_fail',
          data: { direct_announcement_id },
        })).set('amplitude')
      )
      throw e
    }
  })

/** Cancelling answers with the announcement in its new state, so the store takes it. */
export const cancelDirectAnnouncement = (direct_announcement_id: string) =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(putDirectAnnouncementsCancel(direct_announcement_id)))
    dispatch(mergeDirectAnnouncementSlice(resp.data))
    return resp
  })

export const declineDirectAnnouncement = (direct_announcement_id: string, reason?: string) =>
  createThunk(async dispatch => await dispatch(callV2Api(putDirectAnnouncementsDecline(direct_announcement_id, reason))))
